import { useEffect, useState } from "react";

const fmt = (seconds) => {
	const total = Math.max(0, seconds || 0);
	const m = Math.floor(total / 60);
	const s = total - m * 60;
	return `${String(m).padStart(2, "0")}:${s.toFixed(1).padStart(4, "0")}`;
};

// LOCAL TESTING ONLY - temporary panel under the player showing the current session's
// tracked watch time. Rendered only when isWatchDebugEnabled() (development builds). It
// subscribes to the tracker itself so the video player never re-renders because of it.
export default function DebugWatchTime({ tracker }) {
	const [snap, setSnap] = useState(tracker.snapshot);
	useEffect(() => tracker.subscribe(setSnap), [tracker]);
	if (!snap) return null;
	const sync = snap.sync || {};
	return (
		<div
			data-testid='debug-watch-time'
			style={{
				marginTop: 8,
				padding: "6px 10px",
				font: "12px/1.5 monospace",
				color: "#222",
				background: "#fff8c5",
				border: "1px dashed #b58900",
				borderRadius: 4,
				width: "50%",
				boxSizing: "border-box",
			}}>
			<strong>Debug Watch Time:</strong> {fmt(snap.watchedSeconds)}
			<span> (media) / {fmt(snap.wallSeconds)} (real)</span>
			<br />
			speed {snap.rate}x (max {snap.maxRate}x) · {snap.active ? "playing" : "not playing"}
			<br />
			sync: {sync.state} · pending {sync.pending}
			{sync.dropped ? ` · dropped ${sync.dropped}` : ""}
			{sync.lastError ? ` · last error: ${sync.lastError}` : ""}
			<br />
			session {String(snap.sessionId).slice(0, 8)}
		</div>
	);
}
